/*
 * 웹 예약시트를 띄울 수 있는 React(호스트) origin 목록.
 * 운영 빌드는 웹 브리지를 쓰지 않으므로 항상 빈 목록이다.
 */
const DEV_HOST_ORIGINS = [
    'https://dev.frontend.afterdoc.net',
    'https://dev1.frontend.afterdoc.net',
    'https://dev2.frontend.afterdoc.net',
    'https://dev3.frontend.afterdoc.net',
    'https://dev4.frontend.afterdoc.net',
    'https://dev5.frontend.afterdoc.net',
    'https://dev6.frontend.afterdoc.net',
]

const LOCAL_DEFAULT_HOST_ORIGIN = 'http://localhost:3000'

// webPort: 로컬에서 띄운 React(호스트) dev 서버 포트
type HostOriginEnv = { isDevelopment: boolean; isLocal: boolean; webPort?: string }

export const resolveAllowedHostOrigins = ({ isDevelopment, isLocal, webPort }: HostOriginEnv): string[] => {
    if (!isDevelopment) { return [] }
    if (!isLocal) { return [...DEV_HOST_ORIGINS] }
    const origins = [...DEV_HOST_ORIGINS, LOCAL_DEFAULT_HOST_ORIGIN]
    if (!webPort) { return origins }
    const webPortOrigin = `http://localhost:${webPort}`
    return origins.includes(webPortOrigin) ? origins : [...origins, webPortOrigin]
}
